var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.008 2.313V5.7825C37.008 6.08922 36.8862 6.38338 36.6693 6.60027C36.4524 6.81715 36.1582 6.939 35.8515 6.939C34.6246 6.939 33.448 7.42638 32.5804 8.29392C31.7129 9.16147 31.2255 10.3381 31.2255 11.565C31.2255 12.7919 31.7129 13.9685 32.5804 14.8361C33.448 15.7036 34.6246 16.191 35.8515 16.191C36.1582 16.191 36.4524 16.3128 36.6693 16.5297C36.8862 16.7466 37.008 17.0408 37.008 17.3475V20.817C37.008 21.4304 36.7643 22.0188 36.3305 22.4525C35.8968 22.8863 35.3084 23.13 34.695 23.13H2.313C1.69955 23.13 1.11123 22.8863 0.677462 22.4525C0.24369 22.0188 0 21.4304 0 20.817V17.3475C0 17.0408 0.121845 16.7466 0.338731 16.5297C0.555617 16.3128 0.849777 16.191 1.1565 16.191C2.38339 16.191 3.56003 15.7036 4.42758 14.8361C5.29512 13.9685 5.7825 12.7919 5.7825 11.565C5.7825 10.3381 5.29512 9.16147 4.42758 8.29392C3.56003 7.42638 2.38339 6.939 1.1565 6.939C0.849777 6.939 0.555617 6.81715 0.338731 6.60027C0.121845 6.38338 0 6.08922 0 5.7825V2.313C0 1.69955 0.24369 1.11123 0.677462 0.677462C1.11123 0.243691 1.69955 0 2.313 0H34.695C35.3084 0 35.8968 0.243691 36.3305 0.677462C36.7643 1.11123 37.008 1.69955 37.008 2.313Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5049,
    cy: 10.9141,
    r: 4.626,
    fill: "var(--yellow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketimg);
export default __webpack_public_path__ + "static/media/ticketimg.b2ed3879.svg";
export { ForwardRef as ReactComponent };